"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _reactDom = _interopRequireDefault(require("react-dom"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _StyledButton = _interopRequireWildcard(require("../StyledButton"));

var _TitleBox = _interopRequireDefault(require("./components/TitleBox"));

var _Elements = require("./Elements");

var _errors = _interopRequireDefault(require("./errors"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

/* eslint-disable react/no-find-dom-node */
var Modal = /*#__PURE__*/(0, _react.forwardRef)(function (_ref, ref) {
  var button = _ref.button,
      buttons = _ref.buttons,
      children = _ref.children,
      closeButton = _ref.closeButton,
      customTitle = _ref.customTitle,
      id = _ref.id,
      infiniteScroll = _ref.infiniteScroll,
      fullWidth = _ref.fullWidth,
      fullHeight = _ref.fullHeight,
      fullScreenHeight = _ref.fullScreenHeight,
      fullScreen = _ref.fullScreen,
      noTitle = _ref.noTitle,
      masked = _ref.masked,
      onClose = _ref.onClose,
      size = _ref.size,
      width = _ref.width,
      height = _ref.height,
      titleMessageId = _ref.titleMessageId,
      titleValues = _ref.titleValues,
      dialog = _ref.dialog,
      secondary = _ref.secondary,
      svg = _ref.svg,
      titleRightContent = _ref.titleRightContent,
      closeOnClickout = _ref.closeOnClickout,
      closeOnEsc = _ref.closeOnEsc;

  var _useState = (0, _react.useState)(false),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      visible = _useState2[0],
      setVisible = _useState2[1];

  var _useState3 = (0, _react.useState)(true),
      _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
      focusedToClose = _useState4[0],
      _setFocusToClose = _useState4[1];

  var _useState5 = (0, _react.useState)(false),
      _useState6 = (0, _slicedToArray2["default"])(_useState5, 2),
      scrollState = _useState6[0],
      setScrollState = _useState6[1];

  var _useState7 = (0, _react.useState)(false),
      _useState8 = (0, _slicedToArray2["default"])(_useState7, 2),
      didMount = _useState8[0],
      setDidMount = _useState8[1];

  var setFocusToCloseRef = (0, _react.useRef)(null);
  var theDocument = document;
  (0, _errors["default"])({
    id: id,
    infiniteScroll: infiniteScroll,
    buttons: buttons,
    dialog: dialog
  });

  var modalScrollHandler = function modalScrollHandler() {
    if (document.getElementById(id).scrollTop > 0) {
      setScrollState(true);
    } else {
      setScrollState(false);
    }
  };

  var _closeModal = function closeModal() {
    if (document.getElementById(id)) {
      document.getElementById(id).removeEventListener('scroll', modalScrollHandler);
    }

    setVisible(false);
  }; // This lets us encapsulate the logic for showing entirely in the modal
  // while letting sibling components call showModal. Avoids needing it to be a child
  // of the icon.


  (0, _react.useImperativeHandle)(ref, function () {
    return {
      showModal: function showModal() {
        setVisible(true);
      },
      closeModal: function closeModal() {
        return _closeModal();
      },
      setFocusToClose: function setFocusToClose() {
        return _setFocusToClose(true);
      }
    };
  });
  (0, _react.useEffect)(function () {
    var handleEscape = function handleEscape(e) {
      if (e.key === 'Escape' && closeOnEsc) {
        _closeModal();
      }

      if (e.key === 'Enter') {
        e.preventDefault();
      }
    };

    if (didMount) {
      if (focusedToClose) {
        var _setFocusToCloseRef$c, _setFocusToCloseRef$c2;

        // eslint-disable-next-line no-unused-expressions
        setFocusToCloseRef === null || setFocusToCloseRef === void 0 ? void 0 : (_setFocusToCloseRef$c = setFocusToCloseRef.current) === null || _setFocusToCloseRef$c === void 0 ? void 0 : (_setFocusToCloseRef$c2 = _setFocusToCloseRef$c.focus) === null || _setFocusToCloseRef$c2 === void 0 ? void 0 : _setFocusToCloseRef$c2.call(_setFocusToCloseRef$c);
      }

      if (visible) {
        window.addEventListener('keydown', handleEscape);
        theDocument.body.style.maxHeight = '100vh';
        theDocument.body.style.overflow = 'hidden';
        document.getElementById(id).addEventListener('scroll', modalScrollHandler);
      }

      if (!visible) {
        if (onClose) {
          onClose();
        }

        theDocument.body.style.maxHeight = '';
        theDocument.body.style.overflow = '';
      }
    }

    setDidMount(true);
    return function () {
      setDidMount(false);
      theDocument.body.style.maxHeight = '';
      theDocument.body.style.overflow = '';
      window.removeEventListener('keydown', handleEscape);
    }; // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [visible, focusedToClose]);

  var generateTitleBox = function generateTitleBox() {
    if (noTitle) return null;
    return customTitle ? /*#__PURE__*/_react["default"].cloneElement(customTitle, {
      ref: setFocusToCloseRef,
      titleMessageId: titleMessageId,
      titleValues: titleValues,
      svg: svg,
      dialog: dialog,
      secondary: secondary,
      titleRightContent: titleRightContent,
      closeButton: closeButton,
      closeModal: _closeModal,
      setFocusToClose: _setFocusToClose,
      scrollState: scrollState,
      onBlur: function onBlur() {
        return _setFocusToClose(false);
      },
      size: size,
      width: width
    }) : /*#__PURE__*/_react["default"].createElement(_TitleBox["default"], {
      titleMessageId: titleMessageId,
      titleValues: titleValues,
      svg: svg,
      dialog: dialog,
      secondary: secondary,
      titleRightContent: titleRightContent,
      closeButton: closeButton,
      closeModal: _closeModal,
      setFocusToClose: _setFocusToClose,
      scrollState: scrollState,
      ref: setFocusToCloseRef,
      onBlur: function onBlur() {
        return _setFocusToClose(false);
      },
      scrolled: scrollState,
      size: size,
      width: width
    });
  };

  var titleBox = generateTitleBox();
  var toShow = visible ? children : null;

  var modal = /*#__PURE__*/_react["default"].createElement(_Elements.ModalContainer, {
    masked: masked,
    visible: visible,
    fullScreen: fullScreen,
    fullScreenHeight: fullScreenHeight,
    onClick: function onClick(e) {
      e.stopPropagation();
      e.preventDefault();
      if (closeOnClickout) _closeModal();
    }
  }, /*#__PURE__*/_react["default"].createElement(_Elements.ModalWrapper, {
    fullScreen: fullScreen,
    size: size,
    width: width,
    height: height,
    dialog: dialog,
    secondary: secondary
  }, /*#__PURE__*/_react["default"].createElement(_Elements.ModalBox, {
    onClick: function onClick(e) {
      return e.stopPropagation();
    },
    dialog: dialog,
    secondary: secondary,
    fullHeight: fullHeight,
    width: width,
    height: height
  }, titleBox, /*#__PURE__*/_react["default"].createElement(_Elements.ModalContent, {
    id: id,
    infiniteScroll: infiniteScroll,
    fullWidth: fullWidth,
    hasTitle: !!titleBox,
    size: size,
    width: width,
    tabIndex: "0"
  }, toShow), button && /*#__PURE__*/_react["default"].createElement(_Elements.ModalContentPadding, {
    buttonPosition: button.position,
    top: infiniteScroll,
    size: size,
    bottom: true
  }, /*#__PURE__*/_react["default"].createElement(_StyledButton["default"], {
    secondary: button.secondary,
    tertiary: button.tertiary,
    type: button.type || 'button',
    message: button.message,
    onClick: function onClick(e) {
      e.stopPropagation();
      button.onClick();

      _closeModal();
    },
    onKeyDown: function onKeyDown(e) {
      if (e.key === 'Tab') {
        e.preventDefault();

        _setFocusToClose(true);
      }

      if (e.key === 'Enter') {
        if (button.onKeyDown) {
          button.onKeyDown();
        }

        _closeModal();
      }
    }
  })), buttons && /*#__PURE__*/_react["default"].createElement(_Elements.ModalContentPadding, {
    buttonPosition: buttons.position,
    top: infiniteScroll,
    size: size,
    bottom: true
  }, /*#__PURE__*/_react["default"].createElement(_StyledButton.DoubleButton, {
    cancelMessage: buttons.cancelMessage || 'cta.cancel',
    cancelOnClick: function cancelOnClick() {
      if (buttons.cancelOnClick) {
        buttons.cancelOnClick();
      }

      _closeModal();
    },
    primaryMessage: buttons.primaryMessage,
    primaryType: buttons.primaryType,
    primaryOnClick: function primaryOnClick(e) {
      e.stopPropagation();
      buttons.primaryOnClick();

      _closeModal();
    },
    stacked: dialog && buttons.direction !== 'row',
    cancelButtonDanger: buttons.cancelButtonDanger || false
  })))));

  if (visible) {
    var portal = theDocument.body;
    return /*#__PURE__*/_reactDom["default"].createPortal(modal, portal);
  }

  return null;
});
Modal.propTypes = {
  button: _propTypes["default"].shape({
    message: _propTypes["default"].oneOfType([_propTypes["default"].element, _propTypes["default"].string]),
    onClick: _propTypes["default"].func.isRequired,
    type: _propTypes["default"].oneOf(['button', 'submit', 'reset', 'danger']),
    position: _propTypes["default"].string,
    onKeyDown: _propTypes["default"].func,
    onKeyUp: _propTypes["default"].func,
    secondary: _propTypes["default"].bool,
    tertiary: _propTypes["default"].bool
  }),
  buttons: _propTypes["default"].shape({
    cancelMessage: _propTypes["default"].oneOfType([_propTypes["default"].element, _propTypes["default"].string]),
    cancelOnClick: _propTypes["default"].func,
    cancelButtonDanger: _propTypes["default"].bool,
    primaryMessage: _propTypes["default"].oneOfType([_propTypes["default"].element, _propTypes["default"].string]),
    primaryOnClick: _propTypes["default"].func.isRequired,
    primaryType: _propTypes["default"].oneOf(['submit', 'danger']),
    position: _propTypes["default"].string,
    direction: _propTypes["default"].oneOf(['row', 'column'])
  }),
  children: _propTypes["default"].node.isRequired,
  closeButton: _propTypes["default"].bool,
  customTitle: _propTypes["default"].shape(),
  fullWidth: _propTypes["default"].bool,
  fullHeight: _propTypes["default"].bool,
  id: _propTypes["default"].string,
  infiniteScroll: _propTypes["default"].bool,
  masked: _propTypes["default"].bool,
  onClose: _propTypes["default"].func,
  size: _propTypes["default"].string,
  svg: _propTypes["default"].node,
  titleMessageId: _propTypes["default"].string,
  titleValues: _propTypes["default"].shape(),
  // Types
  dialog: _propTypes["default"].bool,
  secondary: _propTypes["default"].bool,
  width: _propTypes["default"].number,
  height: _propTypes["default"].number,
  fullScreen: _propTypes["default"].bool,
  fullScreenHeight: _propTypes["default"].bool,
  noTitle: _propTypes["default"].bool,
  titleRightContent: _propTypes["default"].node,
  closeOnClickout: _propTypes["default"].bool,
  closeOnEsc: _propTypes["default"].bool
};
Modal.defaultProps = {
  button: null,
  buttons: null,
  closeButton: false,
  fullWidth: false,
  fullHeight: false,
  id: 'open-modal',
  infiniteScroll: false,
  masked: true,
  onClose: undefined,
  size: 'medium',
  titleMessageId: null,
  titleValues: {},
  svg: null,
  dialog: false,
  secondary: false,
  fullScreen: false,
  fullScreenHeight: false,
  noTitle: false,
  titleRightContent: null,
  customTitle: null,
  width: null,
  height: null,
  closeOnClickout: true,
  closeOnEsc: true
};
Modal.displayName = 'Modal';
var _default = Modal;
exports["default"] = _default;